export default "__VITE_ASSET__xw$lqdI$__"